export default __webpack_public_path__ + "static/media/laval21.588a4054.jpg";